import { jsx as c } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { IconButton as i } from "@mui/material";
const f = (n) => {
  const o = s(6);
  let t, r;
  o[0] !== n ? ({
    children: t,
    ...r
  } = n, o[0] = n, o[1] = t, o[2] = r) : (t = o[1], r = o[2]);
  let e;
  return o[3] !== t || o[4] !== r ? (e = /* @__PURE__ */ c(i, { ...r, children: t }), o[3] = t, o[4] = r, o[5] = e) : e = o[5], e;
};
export {
  f as IconButton
};
